/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M11.7857 1.9313A8.5305 8.5305 0 0 1 12 1.9286h.0184l.1959.0048v-.2191a.2143.2143 0 0 0-.4286 0v.217Zm1.9286 18.6401-.0115.2c-.0651.5603-.4004 1.0382-.8722 1.3a1.7062 1.7062 0 0 1-.8306.2143l-.1999-.0115a1.7028 1.7028 0 0 1-.6307-.2028c-.527-.2924-.8837-.8545-.8837-1.5h3.4286Zm1.7143 0h7.7143a.8572.8572 0 0 0 0-1.7143h-2.5715v-8.5714c0-4.1468-2.9447-7.6058-6.8571-8.4v-.1714C13.7143.7675 12.9468 0 12 0s-1.7143.7675-1.7143 1.7143v.1715c-3.9124.7941-6.8571 4.2531-6.8571 8.3999v8.5714H.857a.8572.8572 0 0 0 0 1.7143h7.7143C8.5714 22.465 10.1065 24 12 24s3.4286-1.535 3.4286-3.4286ZM5.1429 10.2857l.0084-.3422C5.3296 6.3154 8.3277 3.4285 12 3.4285l.3422.0085c3.6281.1783 6.5149 3.1764 6.5149 6.8487v8.5714H5.1429v-8.5714Z"
    clipRule="evenodd"
  />,
  'Notifications'
);
